/**
 * Field Constants
 *
 * Shared form input options for the Event Key
 * field used for creating new metrics. This object
 * can be retired once the `metrics-fuzzy-search-ui`
 * experiment is complete
 */
// Blocklist: reject Unicode control characters (C0: U+0000–U+001F, DEL: U+007F, C1: U+0080–U+009F).
// oxlint-disable-next-line no-control-regex
export const EVENT_KEY_PATTERN = /^[^\u0000-\u001F\u007F\u0080-\u009F]*$/;
export const EVENT_KEY_PATTERN_MESSAGE = 'Event keys may not contain control characters';

export const FieldConstants = {
  key: 'eventKey',
  label: 'Event key',
  placeholder: 'Enter new or existing event key',
  registerOptions: {
    required: 'Event key is required',
    maxLength: {
      value: 768,
      message: 'Event keys may not exceed 768 characters',
    },
    pattern: {
      value: EVENT_KEY_PATTERN,
      message: EVENT_KEY_PATTERN_MESSAGE,
    },
  },
  toolTipText: 'Add this event key to your codebase to let your SDK track actions taken in your app as events',
  warehouseToolTipText:
    'Identify this metric by specifying the event key column in your metric data source configuration',
} as const;
